var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94585 2.79102C9.60502 2.79102 9.28585 2.62435 9.09085 2.34518L8.34335 1.27268C7.91502 0.657682 7.21252 0.291016 6.46335 0.291016C5.41919 0.291016 3.64419 0.291016 2.33335 0.291016C1.06752 0.291016 0.041687 1.31685 0.041687 2.58268V13.416C0.041687 14.0235 0.283354 14.6068 0.71252 15.0368C1.14252 15.466 1.72585 15.7077 2.33335 15.7077H15.6667C16.2742 15.7077 16.8575 15.466 17.2875 15.0368C17.7167 14.6068 17.9584 14.0235 17.9584 13.416V5.08268C17.9584 4.47518 17.7167 3.89185 17.2875 3.46185C16.8575 3.03268 16.2742 2.79102 15.6667 2.79102H9.94585ZM9.94585 4.04102H15.6667C15.9434 4.04102 16.2075 4.15102 16.4034 4.34602C16.5984 4.54185 16.7084 4.80602 16.7084 5.08268V13.416C16.7084 13.6927 16.5984 13.9569 16.4034 14.1527C16.2075 14.3477 15.9434 14.4577 15.6667 14.4577H2.33335C2.05669 14.4577 1.79252 14.3477 1.59669 14.1527C1.40169 13.9569 1.29169 13.6927 1.29169 13.416V2.58268C1.29169 2.00768 1.75835 1.54102 2.33335 1.54102H6.46335C6.80419 1.54102 7.12335 1.70768 7.31835 1.98685L8.06585 3.05935C8.49419 3.67435 9.19585 4.04102 9.94585 4.04102Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1467 11.3151L7.87087 9.2468L9.90337 10.6018C10.1692 10.7793 10.5259 10.7276 10.73 10.4818L12.8134 7.9818C13.0342 7.7168 12.9984 7.32264 12.7334 7.1018C12.4684 6.88097 12.0742 6.9168 11.8534 7.1818L10.1292 9.25014L8.0967 7.89514C7.83087 7.71764 7.4742 7.7693 7.27004 8.01514L5.1867 10.5151C4.96587 10.7801 5.0017 11.1743 5.2667 11.3951C5.5317 11.616 5.92587 11.5801 6.1467 11.3151Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic);
export default __webpack_public_path__ + "static/media/analytic.74f35aed5a7cce2db16cb2d421fc4aab.svg";
export { ForwardRef as ReactComponent };